import { logitechContent } from "../brandContent/logitechBrandContent";
import BrandLogo from "/static/images/tenants/logitech/logitech.svg";
import { logitechMeta } from "../brandMetaData/logitechMetaData";
import { logitechPrize } from "../brandPrize/logitechPrize";
import { logitechg } from "../brandThemes/logitechg";

export const LOGITECHRD_brandVariables = {
  tenantId: "logitech-l5vzz", // For picking wich leaderboard to show
  themeId: "logitech",
  gameStyle: "racedays", // For picking wich leaderboard to show
  eventCode: "", // Needed for fetching correct challenge
  gameType: "fm8", // What challenge game
  brandLogoType: "element", // "img" | "element" (svg)
  brandLogo: BrandLogo,
  theme: logitechg,
  leaderboardLength: 5,
  leaderboardEntrys: null,

  prize: logitechPrize,
  disclaimer: null,

  content: logitechContent,

  metaInfo: logitechMeta,
};
